import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Paragraph from '../../components/Paragraph'
import Prompts from '../../components/Prompts'
import lang from '../../stores/lang'
import patient from '../../stores/patient'
import getQualities from '../../utils/getQualities'
import pickTwoFromArr from '../../utils/pickTwoFromArr'

/**
 * Prompts for right after the strengths section in the first session copy of the goal page.
 */
@observer
export default class PostStrengthsPrompts extends Component {
  render() {
    if (patient.fields.strengths.length === 0) {
      return null
    }

    // The patient has chosen a number of strengths. The content of some of these prompts is
    // "random" based on the strengths they have chosen. The strength keys are the keys used to
    // represent the strengths they chose in the patient's profile. The following `strengthKeys`
    // should be an array that looks something like this: ['ART', 'COMMUNICATING_WITH_OTHERS']
    const strengthKeys = pickTwoFromArr(patient.fields.strengths)

    // Qualities are values that Chamisa has assigned to each strength. We need two of those
    // qualities to display to them in the prompt.
    const qualityKeys = pickTwoFromArr(getQualities(strengthKeys))

    // These just get the translations for the randomly selected strengths and qualities.
    const strengths = strengthKeys.map(v => lang.translate(`choices.strength.${v}`).toLowerCase())
    const qualities = qualityKeys.map(v => lang.translate(`choices.quality.${v}`).toLowerCase())

    return (
      <Prompts>
        <Prompts.Q
          str={strengths.length === 1
            ? "prose.youreGoodAtSingular"
            : "prose.youreGoodAtPlural"
          }
          inserts={strengths.length === 1
            ? { s: strengths[0] }
            : { s1: strengths[0], s2: strengths[1] }
          }
        />
        <Prompts.R>
          <Paragraph
            str={strengths.length === 1
              ? "prose.workAtBecomingSingular"
              : "prose.workAtBecomingPlural"
            }
            inserts={strengths.length === 1
              ? { s: strengths[0], q1: qualities[0], q2: qualities[1] }
              : { s1: strengths[0], s2: strengths[1], q1: qualities[0], q2: qualities[1] }
            }
          />
          <Paragraph str="prose.orIfTheySay" centered />
          <Paragraph
            str={strengths.length === 1
              ? "prose.itSoundsLikeGoodAtStrengthsSingular"
              : "prose.itSoundsLikeGoodAtStrengthsPlural"
            }
            inserts={strengths.length === 1
              ? { s: strengths[0], q1: qualities[0], q2: qualities[1] }
              : { s1: strengths[0], s2: strengths[1], q1: qualities[0], q2: qualities[1] }
            }
          />
        </Prompts.R>
        <Prompts.Q
          str="prose.imagineApplyingStrengths"
          inserts={{ q1: qualities[0], q2: qualities[1] }}
        />
        <Prompts.R str="prose.youCanImagine" />
      </Prompts>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Goal/PostStrengthsPrompts1.js